import { setInstallationIdentifier } from "@redux/slices/appStateSlice";
import { setUserInfo } from "@redux/slices/userInfoSlice";
import { useEffect, useRef } from "react";
import { Platform } from "react-native";
import { useDispatch, useSelector } from "react-redux";
// @ts-ignore
import { v4 as uuidv4 } from "uuid";

const useInstallationIdentifier = () => {
  const dispatch = useDispatch();
  const installationIdentifier = useSelector(
    (state: any) => state.appState?.installationIdentifier
  );
  const hasSyncedExternalLogin = useRef(false);
  if (Platform.OS !== "web") {
    useEffect(() => {
      const uuid = uuidv4();
      if (!installationIdentifier) {
        dispatch(setInstallationIdentifier(uuid));
      }
    }, [installationIdentifier]);
  } else if (Platform.OS === "web") {
    useEffect(() => {
      const uuid = uuidv4();
      if (!hasSyncedExternalLogin.current && typeof window !== "undefined") {
        hasSyncedExternalLogin.current = true;
        try {
          const isExternalLogin =
            new URL(window.location.href).searchParams.get("external_login") ===
            "true";
          const storedUserData = localStorage.getItem("userData");
          if (isExternalLogin && storedUserData) {
            dispatch(setUserInfo(JSON.parse(storedUserData)));
          }
        } catch (e) {
          console.error("hasSyncedExternalLogin", e);
        }
      }

      if (
        !installationIdentifier ||
        localStorage.getItem("installation_identifier")
      ) {
        dispatch(
          setInstallationIdentifier(
            localStorage.getItem("installation_identifier") || uuid
          )
        );
      }
    }, [
      installationIdentifier,
      localStorage.getItem("installation_identifier"),
    ]);
  }
};

export default useInstallationIdentifier;
